import styles from './RewardDisplay.module.css';

interface RewardDisplayProps {
    amount: string;
    currency?: string;
    size?: 'sm' | 'md' | 'lg';
}

export function RewardDisplay({ amount, currency = 'USD', size = 'md' }: RewardDisplayProps) {
    const formatted = parseFloat(amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return (
        <span className={`${styles.reward} ${styles[size]}`}>
            <span className={styles.currency}>{currency}</span>
            <span className={styles.amount}>{formatted}</span>
        </span>
    );
}
